export async function setFullStoryIdentity(userId: string, email: string) {
  try {
    const fullstory = window['FS'];
    if (userId && fullstory) {
      fullstory.identify(userId, {
        email,
      });
    }
  } catch (error) {
    console.error('Error setting fullstory idenfity');
  }
}
